module.exports = __webpack_public_path__ + "img/delete_col.135eb18e.svg";